export enum ETokenAsync {
  USER_TOKEN = 'NOITADA-TOKEN',
  USER_ID = 'NOITADA-ID',
  USER_DATA = 'NOITADA-USER',
}



export default ETokenAsync;
